import React from 'react';
import { Link } from 'react-router-dom';


// image

import Abd1 from '../../images/about.jpeg';

const about = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <div className={"" +props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-md-12 colsm-12">
                        <div className="wpo-about-text">
                            <div className="wpo-about-title">
                                <span className="sub">À propos</span>
                                <h2 style={{ fontSize: '70px' ,lineHeight: '70px'}}><span>Leaders Diamant Alu  </span> <br /> Expert en fabrication et installation d’aluminium sur mesure</h2>
                            </div>
                            <p>Leaders Diamant Alu, spécialiste en fabrication et installation d’aluminium, propose des solutions sur mesure adaptées à vos projets . Grâce à notre expertise, nous accompagnons aussi bien les particuliers que les professionnels dans la réalisation de portes, fenêtres, façades en Alucobond, garde-corps, murs-rideaux et volets roulants. Nous mettons l’accent sur la qualité des matériaux, la précision d’exécution et l’innovation, afin de garantir des réalisations fiables, modernes et durables.</p>
                            <div className="btns">
                                <Link onClick={ClickHandler} to="/about" className="theme-btn" >En savoir plus</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5 col-md-12 col-sm-12">
                        <div className="wpo-about-img">
                            <img src={Abd1} alt="About us" />
                              
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default about;

